import { Button } from '@mantine/core';
import { useForm } from '@mantine/form';
import { modals } from '@mantine/modals';

export default function ReRunModal({ onSubmit }: { onSubmit?: () => void }) {
  const form = useForm({});

  return (
    <form
      className="flex flex-col gap-3"
      onSubmit={form.onSubmit(() => {
        onSubmit?.();
        modals.close('rerun-config-modal');
      })}
    >
      <div className="flex flex-row justify-end gap-3">
        <Button
          variant="outline"
          onClick={() => modals.closeAll()}
        >
          Cancel
        </Button>
        <Button type="submit">Continue</Button>
      </div>
    </form>
  );
}
